import * as React from 'react';

// @ts-ignore
import { AUTO_MESSAGE_NAME_CHAR_LIMIT } from './AdminNewAutoMessageCreate';
import assertions from 'lib/assertions';
import FormElement from 'components/FormElement';
// @ts-ignore
import Input from 'components/Input';

type Props = {
  defaultValue?: string;
  handleMessageNameChange: (messageName?: string) => void;
};

export default function AdminNewAutoMessageComposeMessageName(props: Props) {
  const { defaultValue, handleMessageNameChange } = props;
  return (
    <FormElement
      data-test="message-name-input"
      showErrorBeforeBlur
      label="Message name"
      onValidChange={e => handleMessageNameChange(e.target.value)}
      onInvalidChange={() => handleMessageNameChange(undefined)}
      subtext="Give this auto message a name that is easily distinguishable. Message names are only
                visible to you and other administrators."
      validate={e => {
        assertions.lengthLesserThanOrEqualTo(
          e.target.value,
          AUTO_MESSAGE_NAME_CHAR_LIMIT,
          `Please provide a message name under ${AUTO_MESSAGE_NAME_CHAR_LIMIT} characters long.`
        );
      }}
      element={Input}
      elementProps={{
        defaultValue,
        placeholder: '1st Period Attendance, Weekly Lunch Money Balance, Overdue Library Books',
        name: 'messageName',
      }}
    />
  );
}
